import React from 'react';

export const ManufacturingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19 7a1 1 0 0 0-1 1v4.382l-1.447.723a5 5 0 0 1-2.053.534L12 13.618V9a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM5 9h5v4H5V9zm14 10H5v-4h14v4z"/>
  </svg>
);
